'use strict';

var React = require('react');

var SvgCreditCardMajor = function SvgCreditCardMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 4.5a1.5 1.5 0 0 1 1.5-1.5h17a1.5 1.5 0 0 1 1.5 1.5v1.5h-20v-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8v7.5a1.5 1.5 0 0 0 1.5 1.5h17a1.5 1.5 0 0 0 1.5-1.5v-7.5h-20zm7 4h-5v-2h5v2z"
  }));
};

exports.SvgCreditCardMajor = SvgCreditCardMajor;
